export type ReminderTone = 'friendly' | 'firm' | 'final';

export const REMINDER_TONE_OPTIONS: {
  value: ReminderTone;
  label: string;
  short: string;
  description: string;
}[] = [
  {
    value: 'friendly',
    label: 'Friendly',
    short: 'Gentle',
    description: 'Warm reminder — assumes good faith, no threats',
  },
  {
    value: 'firm',
    label: 'Firm',
    short: 'Firm',
    description: 'Direct deadline — professional urgency',
  },
  {
    value: 'final',
    label: 'Final warning',
    short: 'Final',
    description: 'Last notice — service suspension or escalation if relevant',
  },
];

export function defaultReminderTone(daysOverdue: number): ReminderTone {
  if (daysOverdue >= 21) {
    return 'final';
  }
  if (daysOverdue >= 7) {
    return 'firm';
  }
  return 'friendly';
}
